import { useState, useEffect } from "react";
import PlaylistTrack from "./PlaylistTrack";
import Description from "../global/Description";

const PlaylistOverlay = (props) => {
  const {
    mixesData,
    activePlaylist,
    setActivePlaylist,
    playlistOverlayOpen,
    setPlaylistOverlayOpen,
    setDrawerMix,
    setDrawerOpen,
    setPlayingMix,
    setPlayerOpen,
  } = props;

  function replaceAfterLastHyphen(url) {
    const lastHyphenIndex = url.lastIndexOf("-");
    if (lastHyphenIndex === -1) return url;
    return url.slice(0, lastHyphenIndex + 1) + "t500x500.jpg";
  }

  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    if (activePlaylist && activePlaylist.artworkUrl) {
      setImageUrl(replaceAfterLastHyphen(activePlaylist.artworkUrl));
    }
  }, [activePlaylist]);

  return (
    <aside
      className={`playlist__overlay-wrapper ${
        playlistOverlayOpen ? "active" : ""
      }`}
    >
      {activePlaylist ? (
        <>
          <button
            className="ra__button playlist__close"
            onClick={() => {
              setActivePlaylist(null);
              setPlaylistOverlayOpen(false);
            }}
          >
            <span className="ra__arrow">&times;</span>
          </button>
          <div className="playlist__overlay-info-wrapper">
            <div className="playlist__overlay-info">
              <img
                className="playlist__cover"
                src={imageUrl}
                alt={`${activePlaylist.title}`}
              />
              <div className="drawer__section">
                <h2>{activePlaylist.title}</h2>
              </div>
              <div className="drawer__section">
                
                {activePlaylist.description?(
<Description content={activePlaylist?.description} />
                ):''}
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      <div className="playlist__overlay-playlist-wrapper">
        {activePlaylist?.tracks.map((mix, index) => {
          return (
            <PlaylistTrack
              key={index}
              {...{
                mix,
                mixesData,
                setDrawerMix,
                setDrawerOpen,
                setPlayingMix,
                setPlayerOpen,
              }}
            />
          );
        })}
      </div>
    </aside>
  );
};

export default PlaylistOverlay;
